import { Phone, MessageCircle, Navigation } from "lucide-react";
import { site } from "../config/siteConfig";

const actions = [
  {
    id: "call",
    label: "Call",
    href: site.phoneHref,
    icon: Phone,
    external: false,
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    href: site.whatsappHref,
    icon: MessageCircle,
    external: true,
  },
  {
    id: "directions",
    label: "Directions",
    href: site.directionsUrl,
    icon: Navigation,
    external: true,
  },
];

export const MobileActionBar = () => (
  <nav
    aria-label="Quick actions"
    data-testid="mobile-action-bar"
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-brand-line bg-white shadow-[0_-4px_20px_rgba(15,23,42,0.08)] pb-[env(safe-area-inset-bottom)] md:hidden"
  >
    {actions.map(({ id, label, href, icon: Icon, external }) => (
      <a
        key={id}
        href={href}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        data-testid={`mobile-action-${id}`}
        className={`flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand ${
          id === "whatsapp"
            ? "bg-brand-green text-white hover:bg-green-700"
            : "text-brand hover:bg-brand-light"
        }`}
      >
        <Icon className="h-5 w-5" aria-hidden="true" />
        {label}
      </a>
    ))}
  </nav>
);
